module.exports = __webpack_public_path__ + "static/media/professionalDevelopment.90abf6c1.jpg";